(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-deal-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parse(v) { return v ? Date.parse(v.replace(/([+-]\d\d)(\d\d)$/, '$1:$2')) : NaN; }

  function init(root) {
    if (!root || root.hasAttribute('data-bdh-ready')) return;
    root.setAttribute('data-bdh-ready', '');
    var design = !!(window.Shopify && window.Shopify.designMode);
    var link = root.getAttribute('data-card-link');
    var now = Date.now();
    var q = /[?&]bfcm_now=([^&]+)/.exec(location.search);
    if (q) { var t = Date.parse(decodeURIComponent(q[1])); if (!isNaN(t)) now = t; }
    var early = false;
    try { early = localStorage.getItem('rg_bfcm_early') === '1'; } catch (e) {}

    var head = document.querySelector('.header-wrapper--overlay');
    var section = root.closest('.shopify-section');
    if (head && section && section === document.querySelector('#MainContent > .shopify-section')) {
      root.setAttribute('data-bdh-under-header', '');
      // Skip while the sticky header is stuck on scroll, so the hero doesn't jump.
      var fit = function () { if (!head.querySelector('.site-header--stuck')) root.style.setProperty('--bdh-head', head.offsetHeight + 'px'); };
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(head);
      else window.addEventListener('resize', fit);
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bdh-card]'));
    var panels = root.querySelectorAll('[data-bdh-panel]');
    var live = [];
    cards.forEach(function (card) {
      var start = parse(card.getAttribute('data-start'));
      var ends = parse(card.getAttribute('data-ends'));
      var state = 'sealed';
      if (!isNaN(start)) {
        // The theme editor previews every card that has an entry.
        if (design || now >= start || (early && now >= start - 864e5)) state = 'live';
        if (state === 'live' && !design && !isNaN(ends) && now >= ends) state = 'ended';
      }
      card.setAttribute('data-state', state);
      card.disabled = state !== 'live';
      if (state === 'live') live.push(card);
    });

    function select(card) {
      cards.forEach(function (c) { c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
      Array.prototype.forEach.call(panels, function (p) { p.hidden = p.getAttribute('data-bdh-panel') !== card.getAttribute('data-bdh-card'); });
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.getAttribute('data-state') !== 'live') return;
        // The theme editor always switches, so every deal can be previewed.
        if (link && !design) window.location.href = link;
        else select(card);
      });
    });
    root._bdhSelect = function (id) {
      var card = root.querySelector('[data-bdh-card="' + id + '"]');
      if (card && card.getAttribute('data-state') === 'live') select(card);
    };

    if (live.length) {
      var current = live[live.length - 1];
      select(current);
      root.hidden = false;
      // On tablets and phones the row scrolls sideways: start it at the live deal.
      var row = current.parentNode;
      if (row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, current.offsetLeft - row.offsetLeft - 20);
    }
  }

  function initAll() { document.querySelectorAll('[data-bdh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bdh]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-bdh]');
    if (root && root._bdhSelect) root._bdhSelect(e.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqEditorial extends HTMLElement {
    connectedCallback() {
      this.singleOpen = this.getAttribute('data-single-open') !== 'false';
      this.triggers = Array.prototype.slice.call(this.querySelectorAll('.faq-e-trigger'));
      this.triggers.forEach(function (trigger) {
        trigger.addEventListener('click', this.onClick.bind(this, trigger));
      }, this);
    }

    onClick(trigger) {
      if (this.isOpen(trigger)) {
        this.close(trigger);
        return;
      }
      if (this.singleOpen) {
        this.triggers.forEach(function (other) {
          if (other !== trigger && this.isOpen(other)) {
            this.close(other);
          }
        }, this);
      }
      this.open(trigger);
    }

    panelFor(trigger) {
      var id = trigger.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    isOpen(trigger) {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    open(trigger) {
      var panel = this.panelFor(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      // Force layout so the expand animates from height:0.
      void panel.offsetHeight;
      panel.classList.add('is-open');
      panel.style.height = panel.scrollHeight + 'px';
      this.afterTransition(panel, function () {
        // Guard against a fast re-close: only settle if still open.
        if (trigger.getAttribute('aria-expanded') === 'true') {
          panel.style.height = 'auto';
        }
      });
    }

    close(trigger) {
      var panel = this.panelFor(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.height = panel.scrollHeight + 'px';
      // Force layout so the collapse animates from the fixed height.
      void panel.offsetHeight;
      panel.classList.remove('is-open');
      panel.style.height = '0px';
      this.afterTransition(panel, function () {
        // Guard against a fast re-open: only hide if still closed.
        if (trigger.getAttribute('aria-expanded') === 'false') {
          panel.hidden = true;
          panel.style.height = '';
        }
      });
    }

    // Runs cb once the height transition ends, with a timeout fallback so it
    // still fires under prefers-reduced-motion / 0s transitions / missed events.
    afterTransition(panel, cb) {
      var settled = false;
      var finish = function () {
        if (settled) return;
        settled = true;
        panel.removeEventListener('transitionend', onEnd);
        cb();
      };
      var onEnd = function (event) {
        if (event.target === panel && event.propertyName === 'height') finish();
      };
      panel.addEventListener('transitionend', onEnd);
      setTimeout(finish, 500);
    }
  }

  if (!customElements.get('faq-editorial')) {
    customElements.define('faq-editorial', FaqEditorial);
  }

  } catch(e) { console.error(e); }
})();
})();
